module.exports = __webpack_public_path__ + "static/media/menu12.211ad543.jpg";